import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as thirdPaymentActions } from "reducers/thirdPayment";

export const usePaymentsCollection = () => {
    const { recolectionsLoading, recolection = {} } = useSelector((state) => state.thirdPayment);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(recolection)) {
            return;
        }
        if (!recolectionsLoading) {
            const { destinationUrl, jwtName, jwtToken } = recolection;
            const url = `${destinationUrl}?${jwtName}=${jwtToken}`;
            window.open(url, "_blank");
        }
    }, [recolection?.destinationUrl, recolectionsLoading]);

    useEffect(
        () => () => {
            dispatch(thirdPaymentActions.resetThirdPayment());
        },
        [],
    );

    return { loading: recolectionsLoading, error: recolection?.error };
};

export default usePaymentsCollection;
